<template>
  <div class="content">
    <el-alert
      title="请注意！项目负责人最多可选三人，在选择负责人后会出现负责人权重占比输入框，所有负责人权重占比之和必须为100%且单个负责人权重占比不得小于等于0%，请确认内容后再提交。"
      style="margin-bottom: 20px"
      type="warning">
    </el-alert>

    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item :to="{ path: '/share/current' }">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}项目</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>


    <el-form ref="form" :model="form" label-width="auto" :inline="true" :rules="rules"
             style="width: 65%;min-width: 800px">
      <el-form-item label="项目名称：" prop="proname">
        <el-input style="width:200px" v-model="form.proname" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="负责人：" prop="personid">
        <el-select v-model="form.personid" placeholder="请选择负责人"
                   multiple
                   filterable
                   @change="changeUser"
                   :multiple-limit="3"
                   default-first-option
                   style="width:400px">
          <el-option
            v-for="item in userData"
            :key="item.id"
            :label="item.person"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="zhanbi">
        <el-form-item label="负责人权重：" v-if="personData.length!=0">
          <el-input v-for="(item,index) in personData" :key="index" style="max-width:300px;margin-top: 5px" v-model="item.propo"
                    placeholder="请输入该负责人权重" type="number">
            <template slot="prepend">{{ item.departemnts }} - {{ item.person }}:</template>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <el-form-item label="项目类别：" prop="project_type">
<!--        <el-input style="width:200px" v-model="form.project_type" placeholder="请输入项目类别"></el-input>-->
        <el-select v-model="form.project_type" placeholder="请选择项目类别" style="width:200px">
          <el-option
            v-for="item in leibie"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="甲方简称：" prop="jiafang">
        <el-input style="width:200px" v-model="form.jiafang" placeholder="请输入甲方简称"></el-input>
      </el-form-item>
      <el-form-item label="甲方签约公司：" prop="jiafang_conpany">
        <el-input style="width:200px" v-model="form.jiafang_conpany" placeholder="请输入甲方签约公司"></el-input>
      </el-form-item>
      <el-form-item label="乙方签约公司：" prop="sign_company">
        <el-input style="width:200px" v-model="form.sign_company" placeholder="请输入乙方简称"></el-input>
      </el-form-item>
      <el-form-item label="合同金额（万元）：" prop="contract_amount">
        <el-input style="width:200px;padding-right: 0px" v-model="form.contract_amount" type="number"
                  placeholder="请输入合同金额"></el-input>
      </el-form-item>

      <el-form-item label="招投标/入库启动日期：" prop="warehousing_date">
        <el-date-picker
          v-model="form.warehousing_date"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:200px"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="合同草拟日期：" prop="drafting_date">
        <el-date-picker
          v-model="form.drafting_date"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:200px"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="合同签订日期：" prop="sign_date">
        <el-date-picker
          v-model="form.sign_date"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:200px"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="项目启动日期：" prop="start_date">
        <el-date-picker
          v-model="form.start_date"
          type="date"
          style="width:200px"
          value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
<!--      <el-form-item label="项目关闭日期：" prop="closing_time">-->
<!--        <el-date-picker-->
<!--          v-model="form.closing_time"-->
<!--          type="date"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          style="width:200px"-->
<!--          placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
      <el-form-item label="是否交付：" prop="isdeliver" class="jiaofu">
        <el-switch
          style="display: block;margin-top: 10px;font-size: 14px"
          v-model="form.isdeliver"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="已交付"
          inactive-text="未交付"
          :inactive-value="0"
          :active-value="1"
        >
        </el-switch>
      </el-form-item>
      <div>
      <el-form-item label="操作：">
        <el-button type="primary" @click="uodata" class="btn-submit1">提交</el-button>
        <el-button @click="fanhui" class="btn-submit1 cancel">返回</el-button>
      </el-form-item>
      </div>
    </el-form>

  </div>
</template>

<script>
import {create_project, get_department, get_departments, get_project, mod_project} from "../../api/user";

export default {
  data() {
    return {
      leibie:[
        {
          value:'投资',
          label:'投资'
        },{
          value:'客研',
          label:'客研'
        },{
          value:'定位',
          label:'定位'
        },{
          value:'培训',
          label:'培训'
        },{
          value:'系统',
          label:'系统'
        },{
          value:'战略',
          label:'战略'
        },{
          value:'数据',
          label:'数据'
        },
      ],

      form: {
        projectid: '',
        personid: [],
        proname: '',
        project_type: '',
        jiafang: '',
        jiafang_conpany: '',
        sign_company: '',
        contract_amount: '',
        sign_date: '',
        start_date: '',
        accounts_receivable: '',
        // invoice_amount:'',
        invoiced_uncollected_payment: '',
        warehousing_date: '',
        drafting_date: '',
        // closing_time: '',
        isdeliver: 0
      },
      rules: {
        // drafting_date: [
        //   {required: true, message: '请选择合同草拟日期', trigger: 'change'}
        // ],
        // closing_time: [
        //   {required: true, message: '请选择项目关闭日期', trigger: 'change'}
        // ],
        proname: [
          {required: true, message: '请输入项目名称', trigger: 'change'}
        ],
        personid: [
          {required: true, message: '请选择负责人', trigger: 'change'}
        ],
        // sign_date: [
        //   {required: true, message: '请选择合同签订日期', trigger: 'change'}
        // ],
        project_type: [
          {required: true, message: '请输入项目类别', trigger: 'change'}
        ],
        jiafang: [
          {required: true, message: '请输入甲方', trigger: 'change'}
        ],
        jiafang_conpany: [
          {required: true, message: '请输入甲方签约公司', trigger: 'change'}
        ],
        sign_company: [
          {required: true, message: '请输入签约公司', trigger: 'change'}
        ],
        // contract_amount: [
        //   {required: true, message: '请输入合同金额', trigger: 'change'}
        // ],

      },
      userData: [],
      depData: [],
      title: '',
      projectid: '',
      //  组装提交的personid
      personData: []

    }
  },
  methods: {
    fanhui(){
      this.$router.push({path:'/share/current'})
    },
    //提交方法
    uodata() {
      let that = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let pnum = 0

          for (let i = 0; i < this.personData.length; i++) {
            pnum = pnum + parseFloat(this.personData[i].propo)

            if( parseFloat(this.personData[i].propo) <= 0){
              this.$message.error('请注意！单个负责人权重占比不得小于等于0%，请确认内容后再提交。')
              return
            }}
          if(pnum !== 100){
            this.$message.error('请注意！所有负责人权重占比必须为100%且单个负责人权重占比不得小于等于0%，请确认内容后再提交。')
            // for (let i = 0; i < this.personData.length; i++) {
            //   this.personData[i].propo = parseFloat(this.personData[i].propo)*100
            // }
            return
          }
          for (let i = 0; i < this.personData.length; i++) {
            // pnum = pnum + parseFloat(this.personData[i].propo)
            this.personData[i].propo = parseFloat(this.personData[i].propo)/100
          }

          // if(this.form.contract_amount < 0){
          //   this.$message.error('请注意！合同金额不得为负。')
          //   return
          // }
          if (this.title == '修改') {
            let newArr = []
            for (let i = 0; i < this.form.personid.length; i++) {
              let a = ''
              a = this.form.personid[i][this.form.personid.length - 1]
              newArr.push(a)
            }
            this.form.personid = newArr.join(',')
            let params = {
              projectid: this.projectid,
              personid: JSON.stringify(this.personData),
              proname: this.form.proname,
              project_type: this.form.project_type,
              jiafang: this.form.jiafang,
              jiafang_conpany: this.form.jiafang_conpany,
              sign_company: this.form.sign_company,
              contract_amount: this.form.contract_amount,
              sign_date: JSON.parse(JSON.stringify(this.form.sign_date)),
              start_date: this.form.start_date,
              warehousing_date: JSON.parse(JSON.stringify(this.form.warehousing_date)),
              // sign_date: JSON.parse(JSON.stringify(this.form.sign_date)) == null ? '' : JSON.parse(JSON.stringify(this.form.sign_date)),
              // start_date: this.form.start_date == null ? '' : this.form.start_date,
              // warehousing_date: JSON.parse(JSON.stringify(this.form.warehousing_date)) == null ? '' : JSON.parse(JSON.stringify(this.form.warehousing_date)),
              drafting_date: this.form.drafting_date,
              // closing_time: this.form.closing_time,
              isdeliver: this.form.isdeliver
            }
            mod_project(params).then(res => {
              if (res.code === 200) {
                this.$message.success('修改成功')
                this.form = {}
                this.fanhui()
              } else {
                this.$message.error(res.msg)
                this.form.personid = []
                for (let i = 0; i < this.personData.length; i++) {
                  this.form.personid.push(this.personData[i].personid)
                  this.personData[i].propo = parseFloat(this.personData[i].propo)*100
                }
              }
            })
          } else {
            // console.log(this.form.personid)
            // let newArr = []
            for (let i = 0; i < this.personData.length; i++) {
              delete this.personData[i].person
            }
            // this.form.personid = newArr.join(',')
            let params = {
              personid: JSON.stringify(this.personData),
              proname: this.form.proname,
              project_type: this.form.project_type,
              jiafang: this.form.jiafang,
              jiafang_conpany: this.form.jiafang_conpany,
              sign_company: this.form.sign_company,
              contract_amount: this.form.contract_amount,
              sign_date: this.form.sign_date,
              start_date: this.form.start_date,
              warehousing_date: this.form.warehousing_date,
              drafting_date: this.form.drafting_date,
              // closing_time: this.form.closing_time,
              isdeliver: this.form.isdeliver
            }
            create_project(params).then(res => {
              if (res.code === 200) {
                this.$message.success('添加成功')
                this.form = {}
                this.fanhui()
              } else {
                this.$message.error(res.msg)
                this.form.personid = []
                for (let i = 0; i < this.personData.length; i++) {
                  this.form.personid.push(this.personData[i].personid)
                  this.personData[i].propo = parseFloat(this.personData[i].propo)*100
                }
              }
            })
          }


        } else {
          return false;
        }
      });
      //
      //
      // }
    },


    //选择修改负责人
    changeUser() {
      // console.log(this.form.personid)
      this.personData = []
      for (let i = 0; i < this.form.personid.length; i++) {
        for (let j = 0; j < this.userData.length; j++) {
          if (this.form.personid[i] == this.userData[j].id) {
            let item = {}
            item = {
              personid: this.userData[j].id,
              propo: 0,
              // departid: this.userData[j].departid,
              person: this.userData[j].persona,
              departemnts:this.userData[j].department_name
            }
            this.personData.push(item)
          }
        }
      }
      // console.log(this.personData)
    },


    async getDept() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      await get_departments(params).then(res => {
        if (res.code === 200) {
          this.depData = res.data;
          // this.limit = res.limit;
          // this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getData() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      await get_department(params).then(res => {
        if (res.code === 200) {
          this.userData = res.data;
          for (let i = 0; i < this.userData.length; i++) {
            for (let j = 0; j < this.depData.length; j++) {
              if (this.userData[i].departments_id == this.depData[j].id) {
                // this.tableData[i].departments_id = this.depData[j].id
                this.userData[i].department_name = this.depData[j].department_name
                this.userData[i].departid = this.depData[j].id
                this.userData[i].persona = this.userData[i].person
                this.userData[i].person = this.depData[j].department_name + ' - ' + this.userData[i].person
                this.userData[i].department_name = this.depData[j].department_name
              }
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getAllData() {
      try {
        await this.getDept()
        await this.getData()
      } catch (e) {
      }
    },
    //  获取单个项目
    getProById() {
      let params = {
        projectid: this.projectid
      }
      get_project(params).then(res => {
        if (res.code == 200) {
          this.form = res.data
          this.form['personid'] = []
          this.personData = res.data.proportion

          for (let i = 0; i < this.personData.length; i++) {
            this.form.personid.push(res.data.proportion[i].personid)
            this.personData[i].propo = Number(parseFloat(this.personData[i].propo)*100).toFixed()
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  mounted() {
    this.getAllData()
    this.projectid = this.$route.query.id
    if (this.projectid == 'new') {
      this.title = '新建'
    } else {
      this.title = '修改'
      this.getProById()
    }
  }
}


</script>
<style scoped>
.content >>> .el-form--inline .el-form-item {
  margin-right: 25px;
}
.zhanbi >>> .el-input{
  margin-right: 15px;
}
.btn-submit1{
  width: 200px;
}
.cancel{
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/views/share/depart_xq.vue